export const PROFILE_DETAILS_SUCCESS = 'PROFILE_DETAILS_SUCCESS';
export const PROFILE_DETAILS_FAIL = 'PROFILE_DETAILS_FAIL';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAIL = 'EDIT_PROFILE_FAIL';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CURRENT_APPLICATION = 'CURRENT_APPLICATION';
